export const LOGIN_REQUEST = "loginReducer/LOGIN_REQUEST";
export const LOGIN_SUCCESS = "loginReducer/LOGIN_SUCCESS";
export const LOGIN_FAILED = "loginReducer/LOGIN_FAILED";
export const LOGIN_RESET = "loginReducer/LOGIN_RESET";
